export default "__VITE_ASSET__3f7453c4__"